const getters = {
    isAllLoaded: state => {
        return state.isFontsLoaded && state.isDataLoaded && state.isImagesLoaded
    }
};

export default getters;
